import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, Paper, Radio, RadioGroup, Slider, Tab, Tabs, Tooltip } from "@mui/material";

// location: frontend/qiankun/upstyledpkgs/tui.image-editor-3.15.3
// must yarn remove tui-image-editor @toast-ui/react-image-editor
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt, { SimplePrompt } from "components/UpStyled/Prompt";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

const SegmentImagesBar = ({ imgurl, extra, handleDeleteSegmentImage, handleSetWorkingImage }) => {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [deleteSegmentUrl, setDeleteSegmentUrl] = useState(null);
  return (
    <SuiBox>
      {extra?.segment_imgs?.[imgurl] && extra?.segment_imgs?.[imgurl].length > 0 ? (
        <Paper sx={{ py: 0.5, px: 1, gap: 1, display: "flex" }}>
          {extra?.segment_imgs?.[imgurl].map((x, inx) => (
            <div
              style={{
                background: `repeating-conic-gradient(
        #fff 0 90deg,
        #e3e3e3 0 180deg) 
    0 0/20% 20%`,
                width: 60,
                height: 60,
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => {
                handleSetWorkingImage(x);
              }}
              className="hover-parent"
            >
              <img src={x} alt={"seg_" + inx} style={{ width: 60, height: 60 }} />
              <SuiBox
                className="hover-children"
                sx={{
                  position: "absolute",
                  top: 2,
                  right: 2,
                }}
              >
                <IconButton
                  size="small"
                  color="error"
                  sx={{
                    backgroundColor: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#e3e3e3",
                    },
                    width: 20,
                    height: 20,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteVisible(true);
                    setDeleteSegmentUrl(x);
                  }}
                >
                  <DeleteIcon sx={{ width: 16, height: 16 }} />
                </IconButton>
              </SuiBox>
            </div>
          ))}
        </Paper>
      ) : null}

      {deleteVisible && deleteSegmentUrl ? (
        <Prompt
          heading="Delete Confirmation"
          text={`Are you certain you want to delete this segment image?`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={(e) => {
            handleDeleteSegmentImage(deleteSegmentUrl);
            setDeleteVisible(false);
            setDeleteSegmentUrl(null);
          }}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default SegmentImagesBar;
